import { BaseBus } from './BaseBus';
import { DateFunctions } from '../static/date-functions';
import { v_LocationDetailBus } from './v_LocationDetailBus';
import { EquipFieldData } from './EquipFieldData';
import { CommonFunctions } from '../static/common-functions';
/*
 * hidden - dispatchEquipmentXrefId
 * hidden - dispatchId
 * (checkbox)
 *Equipment Id: systemId
 * Manufacturer: manufacturerName manufacturerId
 * Model : model
 * (Additional Details - button)
 * Serial #: serialNumber
 * Type: manufacturerTypeName manufacturerTypeId
 * Barcode: barcode 
 * Notes: notes
 * Created By: createdBy
 * Date Created: creationDate;
 * (View Inventory Items Used - button)
 */
export class DispatchAttachmentViewBus extends BaseBus
{
    constructor(data: DispatchAttachmentViewBus) { 
        super(data);
        if (data) {
            if (data.costCenterName) {
                this.costCenterNameLong = data.costCenter + " - " + data.costCenterName;
            }
            this.expenseDate = CommonFunctions.getDate(data.expenseDate);
            this.updateDt = CommonFunctions.getDate(data.updateDt);
            this.insertDt = CommonFunctions.getDate(data.insertDt);
            this.addedDate = CommonFunctions.getDate(data.addedDate);

        }

    }

    setId(id: any) {
        this.dispatchAttachmentId = id;
    }
    CID(): any {
        return this.dispatchAttachmentId;
    }
    initialize(data: DispatchAttachmentViewBus) {
        super.initialize(data);
        this.expenseDate = CommonFunctions.getDate(data.expenseDate);
        this.updateDt = CommonFunctions.getDate(data.updateDt);
        this.insertDt = CommonFunctions.getDate(data.insertDt);
        if (!data.addedDate) { this.addedDate = CommonFunctions.getDateNow(); }
        this.sentToPayrollDt = CommonFunctions.getDate(data.sentToPayrollDt);

    }
    setNew(userId: any, date: Date, companyId: any = null, personId: any = null, parentId: any = null, other: any = null) {
        this.addedDate = CommonFunctions.getDateNow();

    }
    setFromForm(data: DispatchAttachmentViewBus) {
        super.setFromForm(data);
        let dateNow = CommonFunctions.getDateNow();
        //this.updateDt = dateNow;
        //if (this.hasId) {
        //    //this.updateDt = dateNow;
        //    this.insertDt = data.insertDt;
        //    this.insertUserId = data.insertUserId;
        //}
        //else {
        //    this.insertDt = dateNow;
        //    this.insertUserId = data.insertUserId;
        //}

    }
    setBeforeSave() {
        //this.insertDt = DateFunctions.getDateTimeWithUTCOffset(this.insertDt);
        // this.updateDt = DateFunctions.getDateTimeWithUTCOffset(this.updateDt);
    }
    setCommon(userId: any, date: Date, companyId: any = null) {
        if (this.hasId) {
          //  this.updateUserId = userId;
        }
        else {
            //this.insertDt = date;
            //this.insertUserId = userId;
            //this.updateUserId = userId;
        }
    }

    visibleToCustomer: boolean;
    photoCount: number;
    approved: boolean;
    billingCodeId: string;
    //inFinance: boolean;
    accountClassId: string;
    accountClass: string;
    divisionName: string;
    costCenter: string;
    stateProvince: string;
    branchCode: string;
    branchName: string;
    costCenterName: string;
    managerName: string;
    lineOfBusiness: string;
    incomeStatementCat: string;
    empNo: string;
    creditCard: string;
    cos: string;
    sentToPayroll: boolean;
    dispatchAttachmentDetailId: string;
    toBeDeleted: boolean;
    dispatchNumber: string;
    dispatchAttachmentId: string;
    attachmentCount: number;
    attachmentDesc: string;
    attachmentUser: string;
    dispatchId: string;
    isReimbursement: boolean;
    ovh: string;
    reimbursementAmount: number;
    expenseDate: Date;
    personId: string;
    reimbursementTypeId: string;
    isNew: boolean;
    reimbursementTypeName: string;
    updateDt: Date;
    addedDate: Date;
    resourceName: string;
    note: string
    insertDt: Date;
    attachmentDetailFullName: string;
    attachment: any;
    attachmentType: string;
    attachmentName: string;
    costCenterNameLong: string;
    trasferFileFromId: string;
    sentToPayrollUserId: string;
    sentToPayrollUserName: string;
    sentToPayrollDt: Date
    isRefrigerant: boolean;
}
